import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, ActivationEnd, NavigationEnd, ParamMap, Router } from '@angular/router';
import { AccessToken, ApplicationService } from 'eas-core-lib';
import { firstValueFrom, lastValueFrom, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  private appService = inject(ApplicationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  title = 'ArmWebComponent';
  runningAsWebComponent = environment.runningAsWebComponent;
  token : string = '';
  path : string = '';
  authenticated: boolean = false;
  readonly LOGIN_PAGE_TOKEN: string = 'token';

  ngOnInit(): void {
    // Commented out bc it causes error due to call to mdm without authtoken as it's not authenticated yet 
    // but we set autheticated = true - kevin.low 12/15/22
    // if (!this.runningAsWebComponent){
    this.appService.start().subscribe(() => {
        setTimeout(() => {
          if (environment.debug) console.log('In ArmWebComponent: AppComponent - this.appService.user = ', this.appService.user);
        }, 0);
      });
    
    this.appService.authenticated.subscribe((authToken: AccessToken) => {
      if (environment.debug) console.log('In ArmWebComponent: AppComponent - User authenticated. authToken =', authToken);
      this.authenticated = true;
    });

    this.token = encodeURIComponent(this.getLoginPageToken());
    if (environment.debug) console.log("In ArmWebComponent: AppComponent - After getting directly from window.location.search this.oneTimeToken = ", this.token);
    this.path = this.getPath();
  }

  private getPath() : string {
    let pathname = window.location.pathname;
    pathname = pathname.slice(1);
    if (pathname.endsWith('/'))
      pathname = pathname.slice(0,-1);
    // this is to deal with /onefunding base href in edsteps - kevin.low 05/17/23
    if (!pathname.startsWith('user-profile') && 
        !pathname.startsWith('contact-verification') &&
        !pathname.startsWith('role-management')){
      pathname = pathname.split('/')[1];
    }
    if (environment.debug) console.log('In ArmWebComponent: AppComponent - pathname = ', pathname);
    return pathname;
  }

  private getLoginPageToken() : string {
    const params = new URLSearchParams(window.location.search);
    return params.get(this.LOGIN_PAGE_TOKEN);
  }
}
